import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendCasosActivosPorContratoId,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/casosActivosAllContratos.json";
import {
  formatDescripcion,
  formatearMensajeBackend,
  ordenarCasosBackend,
  procesarPropiedadMapeo,
  shouldRenderTicket,
} from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  listaCasosActivosAllContratos: any[];
  status: TypeStatus;
  processDefinitionIdDisplayName: string;
  processDefinitionIdVersion: string;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  listaCasosActivosAllContratos: [],
  processDefinitionIdDisplayName: "",
  processDefinitionIdVersion: "",
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const listaCasosActivosAllContratosSlice = createSlice({
  name: "listaCasosActivosAllContratos",
  initialState,
  reducers: {
    setListaCasosActivosAllContratosPaginado: (
      state,
      action: PayloadAction<{ casos: any[]; numPagina: number }>,
    ) => {
      const { casos, numPagina } = action.payload;

      // Si la página es 0, reemplazamos los datos, si no, concatenamos con los existentes
      if (numPagina === 0) {
        state.listaCasosActivosAllContratos = casos;
      } else {
        state.listaCasosActivosAllContratos = [
          ...state.listaCasosActivosAllContratos,
          ...casos,
        ];
      }
    },
    setListaCasosActivosAllContratos: (
      state,
      action: PayloadAction<{ casos: any[]; numPagina: number }>,
    ) => {
      const { casos, numPagina } = action.payload;

      // Si la página es 1, reemplazamos los datos, si no, concatenamos con los existentes
      if (numPagina === 0) {
        state.listaCasosActivosAllContratos = casos;
      } else {
        state.listaCasosActivosAllContratos = [
          ...state.listaCasosActivosAllContratos,
          ...casos,
        ];
      }
    },

    getListaCasosActivosAllContratos: (state, action: PayloadAction<any[]>) => {
      state.listaCasosActivosAllContratos = action.payload;
    },
    setClearListaCasosActivosAllContratos: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setProcessDefinitionIdDisplayName: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.processDefinitionIdDisplayName = action.payload;
    },
    setProcessDefinitionIdVersion: (state, action: PayloadAction<string>) => {
      state.processDefinitionIdVersion = action.payload;
    },
  },
});
///activos
const procesarCasosActivosAllContratosPaginado = async (casos: any[]) => {
  return await Promise.all(
    casos.map(async (caso) => {
      const {
        alarma,
        descripcion,
        Prioridad,
        ticketRedmine,
        ci,
        Usuario,
        NombreContrato,
      } = caso;
      let partesResumen = [];
      if (alarma) {
        partesResumen.push(`Titulo: ${alarma}`);
      }
      if (descripcion) {
        const value = formatDescripcion(descripcion);
        partesResumen.push(`Descripción: ${value}`);
      }
      if (ci) {
        partesResumen.push(`Ci: ${ci}`);
      }
      if (Prioridad) {
        partesResumen.push(`Prioridad: ${Prioridad}`);
      }
      if (Usuario) {
        partesResumen.push(`Usuario: ${Usuario}`);
      }
      if (NombreContrato) {
        partesResumen.push(`Contrato: ${NombreContrato}`);
      }

      const renderTicketRedmine = shouldRenderTicket(ticketRedmine);

      if (renderTicketRedmine) {
        partesResumen.push(`Ticket Redmine Nro: ${ticketRedmine}`);
      }
      const resumen =
        partesResumen.length > 0
          ? partesResumen.join("\n\n")
          : "No pudimos obtener los datos del caso";

      return {
        ...caso,
        resumen,
      };
    }),
  );
};
const handleLocalhostMock = async (
  datos: any[],
  dispatch: any,
  NumPagina: number,
  Cantidad: number,
  ordenarCasosBackend: (a: any, b: any) => number,
  formatearMensajeBackend: (mensaje: string) => string,
  mock_Json: any,
): Promise<AxiosResponse> => {
  dispatch(setIsLoading(true));
  let response: AxiosResponse<any> = defaultResp;
  response.data = mock_Json;
  let ordenarLista = [...response.data.Data].sort(ordenarCasosBackend);
  const listaFormateada =
    await procesarCasosActivosAllContratosPaginado(ordenarLista);
  dispatch(
    setListaCasosActivosAllContratos({
      casos: listaFormateada,
      numPagina: NumPagina,
    }),
  );
  dispatch(setIsLoading(false));
  dispatch(setStatus("succeeded"));
  dispatch(setSuccess(response.data.Success));

  if (!response.data) {
    response.data = { Data: [] }; // Inicializa data si es undefined
  }

  response.data.Data = listaFormateada;
  return response.data;
};

export const setBackendListaCasosActivosAllContratosPaginado =
  (
    IdCliente: number,
    IdContrato: number,
    TipoTicket: number, // 0 para Activos, 1 para inactivos
    IdCategoria: number,
    Cantidad: number, //2, // 0 para traer todos
    NumPagina: number,
  ): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));

      if (getCurrentDomain() === "localhostCambiar") {
        return await handleLocalhostMock(
          [],
          dispatch,
          NumPagina,
          Cantidad,
          ordenarCasosBackend,
          formatearMensajeBackend,
          mock_Json,
        );
      }
      try {
        let response: AxiosResponse = defaultResp;
        response = await BackendCasosActivosPorContratoId(
          IdCliente, //cero para que traiga todos los cliente
          IdContrato, //cero para que traiga todos los contratos
          TipoTicket,
          IdCategoria,
          Cantidad,
          NumPagina,
        );

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let ordenarLista = [...(response.data.Data || [])].sort(
            ordenarCasosBackend,
          );
          const listaFormateada =
            await procesarCasosActivosAllContratosPaginado(ordenarLista);
          dispatch(
            setListaCasosActivosAllContratosPaginado({
              casos: listaFormateada,
              numPagina: NumPagina,
            }),
          );
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
          if (!response.data) {
            response.data = { Data: [] };
          }
          response.data.Data = listaFormateada;
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));

        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          let response: AxiosResponse<any> = defaultResp;
          response.data = mock_Json;

          const mockData: any = mock_Json;
          const isErrorMock =
            mockData?.Success === false ||
            (mockData?.ResultadoSolicitud !== undefined &&
              mockData?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
          } else {
            let ordenarLista = [...(response.data.Data || [])].sort(
              ordenarCasosBackend,
            );
            ordenarLista = procesarPropiedadMapeo(ordenarLista, "prioridad");
            const listaFormateada =
              await procesarCasosActivosAllContratosPaginado(ordenarLista);
            dispatch(
              setListaCasosActivosAllContratos({
                casos: listaFormateada,
                numPagina: NumPagina,
              }),
            );
            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));
            if (!response.data) {
              response.data = { Data: [] };
            }
            response.data.Data = listaFormateada;
          }
          dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
          const mock401 = await import("../../../dataJson/401.json");
          if (mock401.status === 401) {
            dispatch(setStatus("noAutorice"));
            dispatch(
              setMensaje(
                formatearMensajeBackend(
                  "Tu sesión ha expirado. Vuelve a iniciar sesión",
                ),
              ),
            );
          }
        }
      }
    };

export const setBackendListaCasosActivosAllContratos =
  (
    TipoTicket: number, // 0 para Activos, 1 para inactivos
    IdCategoria: number,
    Cantidad: number, //2, // 0 para traer todos
    NumPagina: number,
    datos: any[],
  ): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));

      if (getCurrentDomain() === "localhost") {
        return await handleLocalhostMock(
          datos,
          dispatch,
          NumPagina,
          Cantidad,
          ordenarCasosBackend,
          formatearMensajeBackend,
          mock_Json,
        );
      }
      try {
        let allData: any[] = [];
        let response: AxiosResponse = defaultResp;
        const contratosPromises = datos.map(async (contrato) => {
          const { cliente, IdContrato } = contrato;
          const { IdCliente } = cliente;

          if (IdCliente) {
            response = await BackendCasosActivosPorContratoId(
              IdCliente,
              IdContrato,
              TipoTicket,
              IdCategoria,
              Cantidad,
              NumPagina,
            );
            if (response.data?.Data) {
              allData = [...allData, ...response.data.Data];
            }
          }
        });

        await Promise.all(contratosPromises);

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let ordenarLista = allData.sort(ordenarCasosBackend);
          ordenarLista = procesarPropiedadMapeo(ordenarLista, "prioridad");
          const listaFormateada =
            await procesarCasosActivosAllContratosPaginado(ordenarLista);
          dispatch(
            setListaCasosActivosAllContratos({
              casos: listaFormateada,
              numPagina: NumPagina,
            }),
          );
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
          if (!response.data) {
            response.data = { Data: [] };
          }
          response.data.Data = listaFormateada;
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));

        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          let allData: any[] = [];
          let response: AxiosResponse<any> = defaultResp;
          response.data = mock_Json;
          for (const contrato of datos) {
            const { cliente } = contrato;
            const { IdCliente } = cliente;
            if (IdCliente) {
              allData = [...allData, ...(response.data.Data || [])];
            }
          }

          const mockData: any = mock_Json;
          const isErrorMock =
            mockData?.Success === false ||
            (mockData?.ResultadoSolicitud !== undefined &&
              mockData?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
          } else {
            let ordenarLista = [...allData];
            ordenarLista.sort(ordenarCasosBackend);
            const listaFormateada =
              await procesarCasosActivosAllContratosPaginado(ordenarLista);
            dispatch(
              setListaCasosActivosAllContratos({
                casos: listaFormateada,
                numPagina: NumPagina,
              }),
            );
            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));

            if (!response.data) {
              response.data = { Data: [] };
            }
            response.data.Data = listaFormateada;
          }
          dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
          const mock401 = await import("../../../dataJson/401.json");
          if (mock401.status === 401) {
            dispatch(setStatus("noAutorice"));
            dispatch(
              setMensaje(
                formatearMensajeBackend(
                  "Tu sesión ha expirado. Vuelve a iniciar sesión",
                ),
              ),
            );
          }
        }
      }
    };

export const setBackendClearListaCasosActivosAllContratos =
  (): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      try {
        let response: AxiosResponse = defaultResp;
        dispatch(
          setListaCasosActivosAllContratosPaginado({
            casos: [],
            numPagina: 0,
          }),
        );
        dispatch(
          setListaCasosActivosAllContratos({
            casos: [],
            numPagina: 0,
          }),
        );

        dispatch(setIsLoading(false));
        dispatch(setStatus("idle"));
        dispatch(setSuccess(false));
        dispatch(setMensaje(""));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
      }
    };

export const {
  setListaCasosActivosAllContratosPaginado,
  setListaCasosActivosAllContratos,
  getListaCasosActivosAllContratos,
  setClearListaCasosActivosAllContratos,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
  setProcessDefinitionIdDisplayName,
  setProcessDefinitionIdVersion,
} = listaCasosActivosAllContratosSlice.actions;

export default listaCasosActivosAllContratosSlice.reducer;
